import { usePixelLoader } from '~/hooks/usePixelLoader';

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const GA4Pixel = ({ pixelId, marketingCookies }: PixelProps) => {
  usePixelLoader(() => {
    // match valid pixel id: G- followed by 8+ alphanumeric chars
    if (!pixelId?.match(/^G-[A-Z0-9]{8,}$/) || !marketingCookies) {
      return;
    }

    // Prevent duplicate script injection
    if (document.getElementById('ga-pixel')) {
      return;
    }

    const script1 = document.createElement('script');
    script1.id = 'ga-pixel-loader';
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${pixelId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.async = true;
    script2.id = 'ga-pixel';
    script2.innerHTML = `
      (function(){try{
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${pixelId}', {
        page_path: window.location.pathname,
      });
      }catch{/*swallow exception*/}})();
    `;
    document.head.appendChild(script2);

    // Return cleanup function for both scripts
    return () => {
      try {
        if (script1.parentNode) {
          script1.parentNode.removeChild(script1);
        }
      } catch {
        // Script already removed, safe to ignore
      }
      try {
        if (script2.parentNode) {
          script2.parentNode.removeChild(script2);
        }
      } catch {
        // Script already removed, safe to ignore
      }
    };
  }, [pixelId, marketingCookies]);

  return null;
};

export default GA4Pixel;
